import { toI18n } from 'util/i18n';

interface CurrentProfile {
  userId: number;
  userFullName: string;
  moreThanOneCompany: boolean;
  informationType: string;
  disableBankAccountEditButton?: boolean;
}
// determines if current user has permission to edit a user profile
// returns properties and attributes for the edit button
export const postMergeRequestPayrollInformationEditButtonAttrs = (
  currentProfile: CurrentProfile,
  currentUserId: number,
  hasBeenPaidInLast30Days = false
) => {
  let disableButton;
  let buttonContent;

  if (
    currentProfile.userId === currentUserId &&
    !currentProfile.disableBankAccountEditButton
  ) {
    disableButton = false;
    buttonContent = null;
  } else {
    disableButton =
      currentProfile.moreThanOneCompany && hasBeenPaidInLast30Days;
    buttonContent = hasBeenPaidInLast30Days
      ? toI18n('product_usage.hover_text.more_than_one_job', {
          props: {
            employee_name: currentProfile.userFullName,
            information_type: currentProfile.informationType,
          },
        })
      : null;
  }
  return { disabled: disableButton, content: buttonContent };
};
